<template>
  <div id="app">
    <modal 
      :adaptive="true" 
      :max-height="600"
      :min-height="500"
      :height="'100%'"
      name="configModal"
    >
      <button 
        class="close-btn" 
        @click="$modal.hide('configModal')">
        ❌
      </button>
      <config-modal />
    </modal>
    <div 
      class="w-100" 
      style="text-align:center;">
      <img 
        src="./assets/imgs/logo.svg" 
        height="100">
    </div>
    <div class="games-container">
      <div class="container">
        <div class="row">
          <div class="card mx-auto">
            <div class="card-header">
              <span>CrazyBillions Demo UAT Page</span>
              <span style="min-width: 50%;">
                <input 
                  v-model="search" 
                  type="text"
                  placeholder="Search by game name..."
                  class="form-control" >
              </span>
              <span class="total-games">Total Games: {{ games.length }}</span>
            </div>
            <div class="card-body text-center">
              <div 
                v-if="categories.length" 
                id="myBtnContainer">
                <button 
                  :class="{ active: currentCategory === 'all' }"
                  class="btn"
                  @click.prevent="changeCategory('all')"> Show all</button>
                <button 
                  v-for="(category, i) in categories"
                  :key="'filter_category' + i"
                  :class="{ active: currentCategory === category }"
                  class="btn"
                  @click.prevent="changeCategory(category)">{{ category }}</button>
              </div><!-- BtnContainer -->
              <div 
                v-if="isLoading" 
                id="main">Loading...</div>
              <div 
                v-else 
                class="games__wrap">
                <Game 
                  v-for="(game, i) in filterBy(games, search, 'name')"
                  :key="'game_' + i" 
                  :game="game"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from 'vuex';
import Vue2Filters from 'vue2-filters';

import Game from './components/Game';
import ConfigModal from './components/ConfigModal';

export default {
  name: 'App',
  components: { Game, ConfigModal },
  mixins: [Vue2Filters.mixin],
  data() {
  	return {
      categories: [],
      games: [],
      isLoading: false,
      search: '',
      path: '',
			ENDPOINT: 'https://admin-uat.cbcontents.com/api/',
    }
  },
  computed: {
    ...mapGetters(['currentGame', 'currentCategory']),
  },
  async created() {
  	this.path = process.env.NODE_ENV !== "development" ? '' : '';
		await this.getCategories();
    await this.getGames();
  },
  methods: {
  	async getCategories() {
      try {
      	const response = await this.axios.get(this.path + '/static/json/categories.json');
      	if(response.data) {
          this.categories = response.data;
        }
      }catch(e) {

      }
    },
    async getGames() {
      this.isLoading = true;  
      try {
        const response = await this.axios.get( this.ENDPOINT + 'demo/json-games');
        if(response.data) {
          this.games = response.data;
        }
        this.isLoading = false;
      }catch(err) {
        this.isLoading = false;
      }
    },
    changeCategory(category) {
  	  this.$store.commit('SET_ACTIVE_CATEGORY', category);
    },
  },
};
</script>

<style>
  @import "assets/css/main.css";
</style>



// WEBPACK FOOTER //
// src/App.vue